import cx from 'classnames';
import React from 'react';
import {Container} from '~/common/FabricInvitation/EventCreateDesign/components/Container/Container';

import './DesignContainer.sass';

interface DesignContainerProps {
  children?: React.ReactNode;
  className?: string;
}

export const DesignContainer: React.FC<DesignContainerProps> = ({children, className = ''}) => (
  <Container
    className={cx(
      'fabric-design-container event-create-editor im-event-create-editor customize',
      className
    )}
  >
    {children}
  </Container>
);
